import ProcurementLaneType from './ProcurementLaneTypes';

/** Lane Search Actions start */
export const getProcurementLaneListInProgress = (payload) => {
  return { payload, type: ProcurementLaneType.GET_PROCUREMENT_LANE_LIST };
};

export const getProcurementLaneListInSuccess = (payload) => {
  return {
    payload,
    type: ProcurementLaneType.GET_PROCUREMENT_LANE_LIST_SUCCESS,
  };
};

export const getProcurementLaneListInFail = (payload) => {
  return {
    payload,
    type: ProcurementLaneType.GET_PROCUREMENT_LANE_LIST_FAIL,
  };
};

export const setProcurementLaneListRequest = (payload) => {
  return {
    payload,
    type: ProcurementLaneType.SET_PROCUREMENT_LANE_LIST_REQUEST,
  };
};

export const resetProcurementLaneList = (payload) => {
  return {
    payload,
    type: ProcurementLaneType.RESET_PROCUREMENT_LANE_LIST,
  };
};

export const setAddNewLane = (payload) => {
  return { payload, type: ProcurementLaneType.SET_ADD_NEW_LANE };
};

/** Lane Search Actions end */

export const selectedLaneList = (payload) => {
  return { payload, type: ProcurementLaneType.SELECTED_LANE_LIST };
};
